import { AnyAction } from 'redux';

import { SETTINGS_UPDATE } from '../actions/settings-actions';
import { Settings } from '../models/settings';

const initialSettingsReducerState: Settings = {
    isPoolAccount: false,
    mediaBaseUrl: '',
    isImpersonator: false,
};

export const settingsReducer = (state: Settings = initialSettingsReducerState, action: AnyAction): Settings => {
    const { type, settings } = action;
    switch (type) {
        case SETTINGS_UPDATE: {
            return { ...state, ...settings };
        }
        default: {
            return state;
        }
    }
};
